<template>
  <div class="fill-height">


    <v-card class="fill-height">

      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          بررسی درخواست ها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <div v-if="showDialog">
        <see-requerst :model="model" :messages="messages" :building-id="buildingId" :dialogStatus.sync="showDialog"/>
      </div>
      <div v-if="showDialogMsg">
        <message :model-items="modelItem" :unit-list="unitList" :dialogStatus.sync="showDialogMsg"/>
      </div>
      <div v-if="showDialogUintEdit">
        <see-unit-edit-request :model="model" :dialogStatus.sync="showDialogUintEdit"/>
      </div>
      <v-card-text>

        <v-tabs
            @change="onChange_"
            v-model="typeRequest"
            color="deep-purple accent-4"
        >
          <v-tab
              v-if="can('userRequestReport')"
              href="#requestUser"
              key="requestUser"
          >

            <v-badge
            color="red"

            >
              <template v-slot:badge>
                <span>{{count}}</span>
              </template>
              درخواست کاربر
            </v-badge>
          </v-tab>
          <v-tab
              v-if="can('unitEditReport') "
              href="#editUnit"
              key="editUnit"
          >

            <v-badge
                color="red"
            >
              <template v-slot:badge>
                <span>{{count2}}</span>
              </template>
              درخواست ویرایش واحد
            </v-badge>
          </v-tab>
          <v-tabs-items v-model="typeRequest">
            <v-tab-item value="requestUser">
              <v-container fluid>
                <v-row>
                  <v-col cols="12"
                         sm="12"
                         md="3"
                  >
                    <v-text-field
                        outlined
                        dense
                        clearable
                        @click:clear="clearable"
                        placeholder="نام شخص"
                        v-model="searchvalue"
                    />

                  </v-col>
                  <v-col
                      cols="12"
                      md="3">
                    <date-picker placeholder="از تاریخ" v-model="dateFrom" color="#3b5694" clearable
                                 auto-submit>
                    </date-picker>
                    <span style="color: red" v-if="getError('dateFrom')" v-text="getError('dateFrom')"/>
                  </v-col>
                  <v-col
                      cols="12"
                      md="3" class="d-inline-flex ">
                    <date-picker placeholder="تا تاریخ" v-model="dateTo" color="#3b5694" clearable
                                 auto-submit>
                    </date-picker>
                    <span style="color: red" v-if="getError('dateTo')" v-text="getError('dateTo')"/>
                    <v-btn fab small color="primary" @click="onChange_" class="mr-1">
                      <v-icon>mdi-cloud-search</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="d-sm-inline-block" cols="12" sm="12"
                         md="12">
                    <b-pagination
                        v-model="skip"
                        :total-rows="paging.totalSize"
                        :per-page=take
                        first-text="اولین"
                        prev-text="<"
                        next-text=">"
                        last-text="آخرین"
                        dir="ltr"
                        limit="5"
                        @change="pageChangeHandler"
                    />

                  </v-col>
                </v-row>
                <v-card-text>

                  <v-card-text>
                    <v-btn-toggle
                        tile
                        v-model="type"
                        dir="ltr"
                        class="m-2"
                        style="float: left"
                        @change="onChange_"
                        rounded
                    >
                      <v-btn small value="all" color="primary">
                        همه
                      </v-btn>

                      <v-btn small value="notSee" color="warning">
                        مشاهده نشده
                      </v-btn>

                      <v-btn small value="see" color="success">
                        مشاهده شده
                      </v-btn>

                    </v-btn-toggle>
                    <b-table
                        v-if="can('requestUserList') && typeRequest==='requestUser'"
                        :items="dataItems"
                        :fields="columns"
                        :current-page="skip"
                        :per-page=0
                        stacked="md"
                        show-empty
                        responsive striped
                    >
                      <template #cell(isRead)="row">
                        <v-chip depressed small v-if="row.item.isRead" color="success">
                          مشاهده شده
                        </v-chip>
                        <v-chip depressed small v-if="!row.item.isRead" color="warning">
                          مشاهده نشده
                        </v-chip>
                        <v-chip depressed small v-if="row.item.isResponse" color="secondary">
                          پاسخ داده شده
                        </v-chip>
                        <v-chip depressed small v-if="!row.item.isResponse" color="error">
                          پاسخ نداده شده
                        </v-chip>
                      </template>

                      <template #cell(actions)="row">
                        <v-btn depressed class="mr-1" v-if="can('editRequestUser')" small color="primary"
                               @click="view(row.item)">
                          مشاهده
                        </v-btn>
                        <v-btn depressed class="mr-1" v-if="can('editRequestUser')" small color="accent"
                               @click="forResponse(row.item)">
                          پاسخ
                        </v-btn>
                      </template>

                    </b-table>
                  </v-card-text>
                </v-card-text>
              </v-container>
            </v-tab-item>
            <v-tab-item value="editUnit">
              <v-container fluid>
                <v-row>
                  <v-col cols="12"
                         sm="12"
                         md="3"
                  >
                    <v-text-field
                        outlined
                        dense
                        clearable
                        @click:clear="clearable"
                        placeholder="نام شخص"
                        v-model="searchvalue"
                    />

                  </v-col>
                  <v-col
                      cols="12"
                      md="3">
                    <date-picker placeholder="از تاریخ" v-model="dateFrom" color="#3b5694" clearable
                                 auto-submit>
                    </date-picker>
                    <span style="color: red" v-if="getError('dateFrom')" v-text="getError('dateFrom')"/>
                  </v-col>
                  <v-col
                      cols="12"
                      md="3" class="d-inline-flex ">
                    <date-picker placeholder="تا تاریخ" v-model="dateTo" color="#3b5694" clearable
                                 auto-submit>
                    </date-picker>
                    <span style="color: red" v-if="getError('dateTo')" v-text="getError('dateTo')"/>
                    <v-btn fab small color="primary" @click="onChange_" class="mr-1">
                      <v-icon>mdi-cloud-search</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="d-sm-inline-block" cols="12" sm="12"
                         md="12">
                    <b-pagination
                        v-model="skip"
                        :total-rows="paging.totalSize"
                        :per-page=take
                        first-text="اولین"
                        prev-text="<"
                        next-text=">"
                        last-text="آخرین"
                        dir="ltr"
                        limit="5"
                        @change="pageChangeHandler"
                    />

                  </v-col>
                </v-row>
                <v-card-text>
                  <v-card-text>
                    <v-btn-toggle
                        tile
                        v-model="type"
                        dir="ltr"
                        class="m-2"
                        style="float: left"
                        @change="onChange_"
                        rounded
                    >
                      <v-btn small value="all" color="primary">
                        همه
                      </v-btn>

                      <v-btn small value="notSee" color="warning">
                        مشاهده نشده
                      </v-btn>

                      <v-btn small value="see" color="success">
                        مشاهده شده
                      </v-btn>

                    </v-btn-toggle>

                    <b-table

                        :items="dataItems"
                        :fields="columns2"
                        :current-page="skip"
                        :per-page=0
                        stacked="md"
                        show-empty
                        responsive striped
                    >

                      <template #cell(isRead)="row">
                        <v-chip depressed outlined small v-if="row.item.isRead" color="success">
                          مشاهده شده
                        </v-chip>
                        <v-chip depressed small outlined v-if="!row.item.isRead" color="warning">
                          مشاهده نشده
                        </v-chip>
                        <v-chip class="mr-1" depressed outlined small v-if="row.item.isResponse" color="secondary">
                          انجام شده
                        </v-chip>
                        <v-chip class="mr-1" depressed outlined small v-if="!row.item.isResponse" color="error">
                          انجام نشده
                        </v-chip>
                      </template>
                      <template #cell(caption)="row">
                        <span class="single-line-caption">{{row.item.caption}}</span>
                      </template>
                      <template #cell(actions)="row">
                        <v-btn  depressed v-if="can('unitEditReport')" small color="primary"
                               @click="view_uint(row.item)">
                          مشاهده
                        </v-btn>
                        <v-btn depressed class="mr-1" v-if="can('unitEditReport') && !row.item.isResponse" small
                               color="warning"
                               @click="response_unit(row.item)">
                          انجام
                        </v-btn>
                      </template>

                    </b-table>

                  </v-card-text>
                </v-card-text>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapMutations} from "vuex";
import Request_se from "@/views/define/requestUser/Request_se";
import SeeRequerst from "@/views/define/requestUser/SeeRequerst";
import SeeUnitEditRequest from "@/views/define/requestUser/SeeUnitEditRequest.vue";
import Message from "@/views/define/message/PageEdit"
import Message_se from "@/views/define/message/Message_se";

export default {
  name: 'RequestUser',
  components: {
    SeeRequerst,
    SeeUnitEditRequest,
    Message
  },
  data() {
    return {

      type: 'all',
      searchvalue: '',
      buildingId: '',
      dateFrom: '',
      dateTo: '',
      model: {},
      modelItem: {},
      unitList: [],
      bindingErrors: [],
      requestTypeItem: [],
      typeRequest: 'requestUser',
      paging: {},
      count: 0,
      count2: 0,
      skip: 1,
      take: 10,
      showDialog: false,
      showDialogMsg: false,
      showDialogUintEdit: false,
      currentPage: 1,
      dataItems: [],
      messages: [],

      columns: [
        {key: 'user.person.fullName', label: 'نام شخص',},
        {key: 'user.userName', label: 'شماره موبایل', },
        {key: 'createdTx', label: 'تاریخ ارسال درخواست', },
        {key: 'viewDateTx', label: 'تاریخ مشاهده', },
        {key: 'lastResponseDateTx', label: 'تاریخ اخرین پاسخ', },
        {key: 'isRead', label: 'وضعیت', },
        {key: 'actions', label: 'عملیات'}
      ],
      columns2: [
        {key: 'type', label: 'نوع',},
        {key: 'buildingName', label: 'نام مجتمع',},
        {key: 'unitName', label: 'نام واحد',},
        {key: 'fullName', label: 'نام شخص',},
        {key: 'mobile', label: 'شماره موبایل', },
        {key: 'caption', label: 'درخواست', },
        {key: 'requestDateTxt', label: 'تاریخ درخواست', },
        {key: 'lastResponseDateTx', label: 'تاریخ انجام', },
        {key: 'isRead', label: 'وضعیت', },
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('RequestUser', () => {
      this.getPage()
      this.fillDataItems()
    })
    this.$root.$on('UnitEditReport', () => {
      this.getPage()
      this.report_unit()
    })

  },

  methods: {
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },

    close() {
      this.searchvalue = ''
      this.$router.push('/home')

    },

    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),

    view(e) {
      Request_se.view(e.id).then(response => {
        this.model = response.data.model
        this.messages = response.data.messages
        this.showDialog = true
      })
    },
    fetch() {
      Request_se.getById(this.modelId).then(response => {
        this.model = response.data.model
        this.showDialog = true
      })
    },

    forEdit: function (e) {
      this.modelId = e.id;
      this.fetch()

    },


    forResponse: function (e) {
      Request_se.response(e.unit.id, e.user.id, e.id).then(response => {
        this.modelItem = response.data;
        this.buildingId = response.data.buildingId;
        this.getUserList(this.buildingId)
        this.showDialogMsg = true

      })
    },
    getUserList(val) {
      Message_se.getUser(val).then(response => {
        return this.unitList = response.data;
      })
    },


    pageChangeHandler: function (event) {
      this.skip = event;
      if (this.typeRequest === 'requestUser') {
        this.fillDataItems()
      } else {
        this.report_unit()
      }

    },
    clearable() {
      this.searchvalue = ""
      this.onChange_()
    },
    fillDataItems() {
      Request_se.getList(this.skip - 1, this.take, this.searchvalue, this.dateFrom, this.dateTo, this.type).then(response => {
        this.paging = response.data.page
        this.dataItems = response.data.requestUserList

      });
    },
    // ---------------------
    getPage() {
      Request_se.getPage().then(response => {
        if (response && response.status === 200) {
          this.dateFrom = response.data.from
          this.dateTo = response.data.to
          this.count = response.data.count
          this.count2 = response.data.count2

          this.$nextTick(() => {
            if (this.typeRequest === 'requestUser') {
              this.fillDataItems()
            }
            else {
              this.typeRequest = 'editUnit'
              this.report_unit()
            }

          })
        }


      })

    },
    onChange_() {
      this.skip= 1
      if (this.dateFrom && this.dateTo){
        if (this.typeRequest === 'requestUser') {
          this.fillDataItems()
        } else {
          this.report_unit()
        }
      }

    },
    handleInput(value) {
      this.$emit('input', value)
    },
    // ----------------------
    view_uint(e) {
      Request_se.view_unit(e.id).then(response => {
        this.model = response.data.model
        this.showDialogUintEdit = true
      })
    },
    response_unit(e) {
      this.$confirm("آیا ویرایش واحد انجام شده است؟", "توجه")
          .then(isDestroyed => isDestroyed &&
              Request_se.response_unit(e.id).then(response => {
                if (response && response.status === 200) {
                  this.model = response.data.model
                  this.$snack({type: 'success'})
                  this.report_unit()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )

    },
    report_unit() {
      Request_se.report_unit(this.skip - 1, this.take, this.searchvalue, this.dateFrom, this.dateTo, this.type).then(response => {
        this.paging = response.data.page
        this.dataItems = response.data.requestList

      });
    },

  },

  created() {
    this.setDrawer(false)
    this.getPage();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}
.single-line-caption {
  display: block; /* یا inline-block */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word; /* برای اطمینان بیشتر در برخی مرورگرها */
  max-width: 200px; /* یا هر عرض دلخواه دیگر برای محدود کردن طول */
}
</style>
